import { Brand } from 'cpie-common';

export const fallbackImages = {
    [Brand.AUDI]: '/contents/vwfs/audi_default.svg',
    [Brand.SEAT]: '/contents/vwfs/seat_default.svg',
    [Brand.SKODA]: '/contents/vwfs/skoda_default.svg',
    [Brand.VW]: '/contents/vwfs/vw_default.svg',
    [Brand.CUPRA]: '/contents/vwfs/cupra_default.svg',
};

export const getDefaultVehicleImageByBrand = (brand?: Brand) => {
    switch (brand) {
        case Brand.AUDI:
            return fallbackImages.Audi;
        case Brand.SEAT:
            return fallbackImages.SEAT;
        case Brand.SKODA:
            return fallbackImages.ŠKODA;
        case Brand.VW:
            return fallbackImages.Volkswagen;
        case Brand.CUPRA:
            return fallbackImages.CUPRA;
    }
    return fallbackImages.Volkswagen;
};
